import { createFileRoute } from "@tanstack/react-router";
import { Navbar } from "@/components/Navbar";
import { AgencyHero } from "@/components/AgencyHero";
import { AgencyBenefits } from "@/components/AgencyBenefits";
import { AgencyFeatures } from "@/components/AgencyFeatures";
import { AgencyHowItWorks } from "@/components/AgencyHowItWorks";
import { AgencyCtaBanner } from "@/components/AgencyCtaBanner";
import { DashboardPreview } from "@/components/DashboardPreview";
import { AiAgentSection } from "@/components/AiAgentSection";
import { Pricing } from "@/components/Pricing";
import { Footer } from "@/components/Footer";

export const Route = createFileRoute("/agencies")({
  head: () => ({
    meta: [
      { title: "AdKavi for Agencies — AI Platform Built for Agencies" },
      {
        name: "description",
        content:
          "One dashboard for every client. Run Meta, TikTok, Google & YouTube campaigns with AI doing the heavy lifting.",
      },
      { property: "og:title", content: "AdKavi for Agencies — AI Platform Built for Agencies" },
      {
        property: "og:description",
        content:
          "One dashboard for every client. Run Meta, TikTok, Google & YouTube campaigns with AI doing the heavy lifting.",
      },
      { property: "og:url", content: "https://adkavi.ai/agencies" },
    ],
    links: [{ rel: "canonical", href: "https://adkavi.ai/agencies" }],
  }),
  component: AgenciesPage,
});

function AgenciesPage() {
  return (
    <div className="min-h-screen bg-background text-foreground overflow-x-hidden">
      <Navbar />
      <main>
        <AgencyHero />
        <AgencyBenefits />
        <DashboardPreview />
        <AgencyFeatures />
        <AiAgentSection />
        <AgencyHowItWorks />
        <div id="agency-pricing" className="relative scroll-mt-20">
          <div
            aria-hidden
            className="absolute inset-x-0 top-1/3 h-[28rem] pointer-events-none"
            style={{
              background:
                "radial-gradient(ellipse at 50% 50%, rgba(232,114,26,0.08), transparent 65%)",
            }}
          />
          <div className="relative">
            <Pricing audience="agency" />
          </div>
        </div>
        <AgencyCtaBanner />
      </main>
      <Footer />
    </div>
  );
}
